import React, { ReactElement } from 'react';
import classNames from 'classnames';
import dayjs from 'dayjs';
import 'dayjs/locale/pl';

import Rating from '../rating/rating';
import Link from '../link/link';
import './review-slide.scss';

export interface ReviewInterface {
    author: string;
    product: string;
    url: string;
    description: string;
    score: number;
    date: Date;
}

interface ReviewProps extends ReviewInterface {
    className?: string;
}

dayjs.locale('pl');

const ReviewSlide: React.FC<ReviewProps> = (
    {
        author,
        product,
        url,
        description,
        score,
        date,
        className,
        ...props
    }
): ReactElement => {
    const reviewClasses = classNames(className, 'review-slide__wrapper');

    return (
        <div className={reviewClasses} {...props}>
            <div className="review-slide">
                <h3 className="review-slide__title">
                    <span className="review-slide__user">
                        {author}
                    </span>
                    &nbsp;dodał opinię o&nbsp;
                    <Link className="review-slide__product" href={url} title={product}>
                        {product}
                    </Link>
                </h3>
                <p className="review-slide__description">
                    {description}
                </p>
                <div className="review-slide__rating">
                    <Rating className="review-slide__score" value={score} readOnly={true} />
                    <div className="review-slide__date">
                        { dayjs(date).format('D MMMM YYYY | HH:mm') }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReviewSlide;
